"use client";

import { Toaster } from "@/components/ui/toaster";
import { Suspense } from "react";
import { PostHogProvider } from "./posthog-provider";
import { Session } from "./session";
import StatsigProvider from "./statsig-provider";
import { ThemeProvider } from "./theme-provider";

interface IProvidersProps {
  children: React.ReactNode;
}

// Loading component for Suspense fallback
const LoadingProvider = () => (
  <div className="flex min-h-screen items-center justify-center" data-oid="y6kl09n">
    <div className="h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-blue-500" data-oid="at32bn5"></div>
  </div>
);

export function Providers({ children }: IProvidersProps) {
  return (
    <Suspense fallback={<LoadingProvider />}>
      <Session>
        <ThemeProvider>
          <PostHogProvider>
            <StatsigProvider>
              {children}
              <Toaster />
            </StatsigProvider>
          </PostHogProvider>
        </ThemeProvider>
      </Session>
    </Suspense>
  );
}
